import React from 'react';
import ChalanUpdateAndReturnComponent from '../ChalanUpdateAndReturn/ChalanUpdateAndReturnComponent';

function StockReturn(props) {
    return (
        <>
            <ChalanUpdateAndReturnComponent is_stock_return={true}/>
        </>
    );
}

export default StockReturn;